import { useEffect } from "react";

import { DeliveryMethod, OrderFields, OrderStep, SHIPMENT_STEP_DELIVERY_METHODS } from "../../constants";
import useOrderData from "../../context/useOrderData";
import useOrderFormik from "../useOrderFormik";

const useUpdateStepsByDeliveryMethod = (): void => {
  const {
    values: { [OrderFields.DELIVERY_METHOD]: deliveryMethod },
  } = useOrderFormik();

  const { updateSteps } = useOrderData();

  useEffect(() => {
    const isShipmentStepVisible = SHIPMENT_STEP_DELIVERY_METHODS.includes(deliveryMethod as DeliveryMethod);
    updateSteps({
      [OrderStep.ShipmentDetails]: isShipmentStepVisible,
      [OrderStep.SenderDetails]: !isShipmentStepVisible,
      [OrderStep.ReceiverDetails]: !isShipmentStepVisible,
    });
  }, [deliveryMethod, updateSteps]);
};
export default useUpdateStepsByDeliveryMethod;
